import { HOLIDAY_ANIMATIONS } from "./Animations";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const resolveUrl = (u) => (!u ? "" : u.startsWith("http") ? u : `${BACKEND}${u}`);

const HOLIDAY_STYLE = {
  weihnachten:  { bg: "linear-gradient(90deg, #0B3B24 0%, #1B6941 50%, #0B3B24 100%)", text: "text-white" },
  ostern:       { bg: "linear-gradient(90deg, #F4EBFA 0%, #E9F5E3 50%, #FDE9F1 100%)", text: "text-[#5B3A1E]" },
  silvester:    { bg: "linear-gradient(90deg, #0A1533 0%, #142B66 50%, #0A1533 100%)", text: "text-[#FFD24A]" },
  tag_der_deutschen_einheit: { bg: "linear-gradient(90deg, #F7F9FA 0%, #FFFFFF 100%)", text: "text-[#1d1d1b]" },
  black_friday: { bg: "linear-gradient(90deg, #000000 0%, #0F0F0F 50%, #000000 100%)", text: "text-[#FFD24A]" },
  weltfrauentag:{ bg: "linear-gradient(90deg, #B94175 0%, #E4477F 50%, #F473A1 100%)", text: "text-white" },
  valentinstag: { bg: "linear-gradient(90deg, #E4477F 0%, #F473A1 50%, #E4477F 100%)", text: "text-white" },
};

const CUSTOM_STYLE = { bg: "linear-gradient(90deg, #2C57D2 0%, #00AAA0 100%)", text: "text-white" };

export default function HolidayBanner({ active }) {
  if (!active || active.key === "karfreitag") return null;
  const isCustom = active.kind === "custom";
  const cfg = isCustom ? CUSTOM_STYLE : (HOLIDAY_STYLE[active.key] || CUSTOM_STYLE);
  const Anim = !isCustom && !active.image_url ? HOLIDAY_ANIMATIONS[active.key] : null;
  const text = (active.greeting && active.greeting.trim()) || (isCustom ? active.name : "");
  const imgSrc = resolveUrl(active.image_url);
  if (!text && !Anim && !imgSrc) return null;
  return (
    <div className="relative overflow-hidden border-b border-[#E3E8EC]" data-testid={`holiday-banner-${active.key}`}
      style={{ background: cfg.bg }}>
      <div className="pointer-events-none absolute inset-0 motion-reduce:hidden" aria-hidden="true">
        {Anim && <Anim />}
      </div>
      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12 h-10 flex items-center justify-center gap-3">
        {imgSrc && (
          <img src={imgSrc} alt="" aria-hidden="true"
            className="h-8 w-auto object-contain pointer-events-none select-none" />
        )}
        <p className={`text-center font-tech text-[11px] sm:text-xs tracking-[0.14em] uppercase font-medium ${cfg.text}`}>
          {text}
        </p>
      </div>
    </div>
  );
}
